<template>
  <div
    :class="['creative-state d-flex justify-content-between align-items-center overflow-hidden', {'isNotActive': isCreativeContentActive === false}]"
    data-test="creative-state"
  >
    <p>
      Creative State:
    </p>
    <p>
      {{ creativeContentStateValue }}
    </p>
    <i
      class="d-flex justify-content-center align-items-center icon far"
      :class="isCreativeContentActive ? 'fa-pause' : 'fa-play'"
      @click="toggleCreativeContentState"
    />
  </div>
</template>
<script>
import {
  mapActions, mapGetters, mapState,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'PlayPauseButton',
  props: {
    contentItem: {
      type: Object,
      default: () => {},
    },
    selectedCreativeContent: {
      type: Object,
      default: () => {},
    },
    isCreativeContentActive: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.UPDATE_A_CREATIVE_CONTENT_STATE,
    ]),
    toggleCreativeContentState() {
      if (!this.isManagedCampaign && !this.isCampaignLive) return;
      const payload = {
        advertiserId: this.selectedAdvertiser.id,
        creativeId: this.selectedCreativeId,
        updatedItem: {
          contentItemUuid: this.selectedCreativeContent?.contentItemUuid,
          active: !this.selectedCreativeContent?.active,
        },
      };
      this.UPDATE_A_CREATIVE_CONTENT_STATE(payload);
    },
  },
  computed: {
    ...mapState('campaigns', [
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'selectedCreativeId',
    ]),
    ...mapGetters('campaigns', {
      isManagedCampaign: campaignTypes.GET_IS_MANAGED_CAMPAIGN,
      isCampaignLive: campaignTypes.GET_IS_CAMPAIGN_LIVE,
    }),
    creativeContentStateValue() {
      return this.isCreativeContentActive ? 'ACTIVE' : 'INACTIVE';
    },
  },
};
</script>
